export default __webpack_public_path__ + "static/media/phone.18451f93.svg";